export default {
  meta: {
    title: '流程配置列表',
  },
};
